var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.765 2.02741L0.775495 19.3285C0.595049 19.6409 0.500033 19.9954 0.5 20.3562C0.499967 20.717 0.594917 21.0714 0.775305 21.3839C0.955693 21.6963 1.21516 21.9558 1.52763 22.1362C1.84009 22.3166 2.19454 22.4115 2.55533 22.4115H22.5327C22.8935 22.4115 23.248 22.3166 23.5605 22.1362C23.8729 21.9558 24.1324 21.6963 24.3128 21.3839C24.4932 21.0714 24.5881 20.717 24.5881 20.3562C24.588 19.9954 24.493 19.6409 24.3126 19.3285L14.3241 2.02741C14.1438 1.71504 13.8844 1.45564 13.572 1.27529C13.2596 1.09495 12.9053 1 12.5446 1C12.1839 1 11.8295 1.09495 11.5171 1.27529C11.2048 1.45564 10.9454 1.71504 10.765 2.02741ZM12.6749 7.36339H12.4143C11.7728 7.36339 11.2527 7.88347 11.2527 8.52502V14.0774C11.2527 14.7189 11.7728 15.239 12.4143 15.239H12.6749C13.3164 15.239 13.8365 14.7189 13.8365 14.0774V8.52502C13.8365 7.88347 13.3164 7.36339 12.6749 7.36339ZM13.8365 18.3506C13.8365 19.0641 13.2581 19.6426 12.5446 19.6426C11.8311 19.6426 11.2527 19.0641 11.2527 18.3506C11.2527 17.6371 11.8311 17.0587 12.5446 17.0587C13.2581 17.0587 13.8365 17.6371 13.8365 18.3506Z",
    fill: "#B26762"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3f3d56ec9aafdba5f55625adc36268d4.svg";
export { ForwardRef as ReactComponent };